<template>
  <div class="child_">
    <a-form layout="horizontal" class="horizontal_item_" :form="form" @submit="ccSubmit">
      <!-- 标的物存放地址始 -->
      <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">租赁标的物存放地址</div>
          <div class="cutoff_"></div>
        </div>
        <a-row class="m_row">
          <a-col :span="6" class="m_span6">
            <a-form-item class="formItem" :label-col="{span: 10}" label="地址1（必填）">
              <a-select @change="(val) => handleProvinceChange(val, 'city1')" v-decorator="[
                  'province1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择省',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district1','city1Options')" v-decorator="[
                  'city1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择市',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city1Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请选择区',
                      },
                    ],
                  },
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district1Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress1',
                  {
                    rules: [
                      {
                        required: true,
                        message: '请输入详细地址',
                      },
                    ],
                  },
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row class="m_row">
          <a-col class="m_span6" :span="6">
            <a-form-item class="formItem" :label-col="{span: 10}" label="地址2（选填）">
              <a-select @change="(val) => handleProvinceChange(val, 'city2')" v-decorator="[
                  'province2'
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district2','city2Options')" v-decorator="[
                  'city2'
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city2Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district2'
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district2Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress2'
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>

        <a-row class="m_row">
          <a-col :span="6" class="m_span6">
            <a-form-item label="地址3（选填）" :label-col="{span: 10}" class="formItem">
              <a-select @change="(val) => handleProvinceChange(val, 'city3')" v-decorator="[
                  'province3'
                ]" class="w120_ mrg_r12_" placeholder="请选择省">
                <a-select-option v-for="item in provsData" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="3">
            <a-form-item>
              <a-select @change="(val) => handleCityChange(val, 'district3','city3Options')" v-decorator="[
                  'city3'
                ]" class="w120_ mrg_r12_" placeholder="请选择市">
                <a-select-option v-for="item in city3Options" :key="item.value" :value="`${item.text}-${item.value}`">
                  {{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col :span="3">
            <a-form-item>
              <a-select v-decorator="[
                  'district3'
                ]" class="w120_ mrg_r12_" placeholder="请选择区">
                <a-select-option v-for="item in district3Options" :key="item.value"
                  :value="`${item.text}-${item.value}`">{{ item.text }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>
          <a-col :span="6">
            <a-form-item>
              <a-input v-decorator="[
                  'maddress3'
                ]" class="w200_" placeholder="请输入详细地址"></a-input>
            </a-form-item>
          </a-col>
        </a-row>
      </a-row>
      <!-- 标的物存放地址末 -->
      <!-- 合计保费 -->
      <!-- <a-row>
        <div id="start" class="title_">
          <div class="cutleft_">预计保费</div>
          <div class="cutoff_"></div>
        </div>
        <a-col :span="24">
          <a-form-item class="m_span3" :label-col="{ span: 3 }" label="预计保费">
            <a-input class="totalPremiumInput" :disabled="true" v-model="totalPremium" />
          </a-form-item>
        </a-col>
      </a-row> -->
    </a-form>
  </div>
</template>

<script>
  import { rentMoney } from '../formRule';
  import '../../../../public/publicCodeFiles/zhongli_zlAddressOptionsC.js'
  import '../../../../public/publicCodeFiles/zhongli_zlAddressOptionsD.js'
  import '../../../../public/publicCodeFiles/zhongli_zlAddressOptionsP.js'
  export default {
    data() {
      return {
        provsData: window.zlAddressOptionsP, //省选择
        city1Options: [],
        city2Options: [],
        city3Options: [],
        district1Options: [],
        district2Options: [],
        district3Options: [],
        planOffsetDay: 0,
        operationType: "",
        rangeConfig: {
          rules: [{ required: true, message: "请选择时间!" }]
        },
        includes03: false,
        policyRiskInfo: [],
        showAddInsuredModal: false,
        editingInsuredInfo: {},
        oneAmount: 0,
        twoAmount: 0,
        totalAmount: 0,
        brackePercentage: 0,
        policyPlanCode: "",
        xgzhongduan: false,
        wmzhongduan: false,
        yiwai: false,
        twoSave: false,
        oneSave: false,
        insureType: "C",
        brackePercentage1: "",
        brackePercentage2: "",
        destination1: "",
        ywbm: 5,
        nationAreaType: "",
        form: this.$form.createForm(this),
      };
    },
    props: {
      termYear: {
        type: Number
      }
    },
    computed: {
      totalPremium: function () {
        let oneAmount = Number(this.oneAmount) || 0;
        let twoAmount = Number(this.twoAmount) || 0;
        return Math.ceil(oneAmount + twoAmount);
      },
    },
    created() {
      const { u, p } = this.$route.query;
      this.userParams = {
        //从地址中获取
        userId: u,
        productCode: p
      };
    },
    beforeDestroy() {
      this.$bus.$off("policyInfo");
    },
    methods: {
      rentMoney,
      //表单提交
      async ccSubmit() {
        let saveData = null
        this.form.validateFields((err, values) => {
          if (!err) {
            saveData = this.submitData(values)
          }
        });
        if(saveData) {
          return saveData
        }
      },
      submitData(values) {
        let province = values.province1;
        let city = values.city1;
        let district = values.district1;
        let detailaddress = values.maddress1;
        if (values.province2 && values.city2 && values.district2) {
          province += `,${values.city2}`
          city += `,${values.province2}`
          district += `,${values.district2}`
          detailaddress += `,${values.maddress2||''}`
        }
        if (values.province3 && values.city3 && values.district3) {
          province += `,${values.city3}`
          city += `,${values.province3}`
          district += `,${values.district3}`
          detailaddress += `,${values.maddress3||''}`
        }
        let bracket1 = "1"
        // 保费类别判断
        if (this.brackePercentage2 == 0.0045) {
          bracket1 = "2";
        }
        const saveData = {
          sourceType: values.bracket == "0.0055" ? "0.0058" : values.bracket,//计划
          nationAreaType: this.nationAreaType,
          creator: this.userParams.userId,
          oneAmount: this.oneAmount,
          province,
          city,
          district,
          detailaddress,
          twoAmount: this.twoAmount,
          policyPlanCode: this.policyPlanCode,
          bracket1,
          bracket2: this.brackePercentage1,
          riskInfos: this.policyRiskInfo
        }
        console.log('data')
        return saveData
      },
      handleProvinceChange(value, fieldKey) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ [fieldKey]: "" });
        let arr = window.zlAddressOptionsC.filter(item => item.provsCode == val)
        this[fieldKey + "Options"] = arr;
      },
      handleCityChange(value, fieldKey) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ [fieldKey]: "" });
        let arr = window.zlAddressOptionsD.filter(item => item.cityCode == val)
        this[fieldKey + "Options"] = arr;
      },
      handlePropertySelect(value) {
        var val = value.split("-")[1];
        this.form.setFieldsValue({ fastmailname: "" });
        this.companyCatagoryList = this.companyPropertyList.filter(
          item => item.name == val
        )[0].childrens;
      },
      splicingAddress(str1, str2, str3) {
        //拼接地址
        if (str2 && str1 && str3) {
          return `${str1},${str2},${str3}`;
        } else if (str2 && str1) {
          return `${str1},${str2}`;
        } else if (str1) {
          return `${str1}`;
        }
      },
      resetForm() {
        this.form.resetFields();
      },
      checkFields() {
        console.log('123')
        //校验form
        this.form.validateFields((err) => {
          if (!err) {
            this.$emit("checked", true);
          } else {
            this.$emit("checked", false);
          }
        });
      },
    }
  };
</script>

<style scoped lang="scss">
  @media screen and (min-width: 500px) {
    $themeC: rgba(254, 143, 45, 1);

    .child_ {
      .mrg_r12_ {
        margin-right: 12px;
      }

      .w200_ {
        width: 200px;
      }

      .w120_ {
        width: 120px;
      }

      .wid_150 {
        width: 300px;
      }

      .marL_10 {
        margin-left: 10px;
      }

      .title_ {
        margin: 30px 0 20px;
        display: flex;
        align-items: center;
        justify-content: space-between;

        .cutleft_ {
          font-size: 16px;
          font-family: Microsoft YaHei UI;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          // width: 10%;
        }

        .cutoff_ {
          // width:90%;
          flex: 1;
          height: 5px;
          background: #f0f0f0;
        }
      }

      .operation {
        text-align: center;
      }

      .operation span {
        display: inline-block;
        background-color: #fe8f2d;
        color: #fff;
        border-radius: 3px;
        padding: 3px 10px;

        &:last-child {
          margin-left: 20px;
        }
      }

      .btn_list {
        display: flex;
        justify-content: center;

        .btn_ {
          margin: 19px;
          border: 1px solid $themeC;
          width: 150px;
          height: 35px;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 16px;

          .btn_a {
            flex: 1;
            text-align: center;
            color: $themeC;
          }
        }
      }

      .btn_color {
        background: $themeC;
        border: 1px solid $themeC;
      }

      .pl_10 {
        padding-left: 10px;
      }

      .planSelect {
        width: 330px;
      }

      .totalPremiumInput {
        width: 300px;
      }
    }
  }

  // 移动端适配
  @media screen and (max-width: 500px) {
    .child_ {
      .planSelect {
        width: 170px;
      }

      .ant-col-10 {
        width: 100%;
      }

      .ant-col-20 {
        width: 100%;
      }

      .ant-form-item-label {
        line-height: 40px;
        font-size: 12px;
      }

      .ant-col-offset-2 {
        margin-left: 0;
      }

      .ant-form-item-required::before {
        margin-right: 0px;
      }

      .m_span3 {
        .ant-col-3 {
          width: 25%;
        }
      }

      .m_row {
        width: 100%;
        display: flex;
        flex-wrap: wrap;

        .m_span6 {
          width: 220px;

          .formItem {
            .ant-col {
              color: red;
            }
          }
        }

        .ant-col-6 {
          width: 220px;
        }

        .ant-col-3 {
          width: 130px;
        }
      }
    }
  }
</style>
<style scoped>
  @media screen and (max-width: 500px) {
    .formItem>>>.ant-form-item-label {
      width: 100px;
      white-space: nowrap;
    }
  }
</style>